import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';

export default function CheckOutDecCard(props) {


    const [billView, setBillView] = useState(false);
    const [imageUrls, setImageUrls] = useState([]); // Stores fetched image URLs

    const [modalImage, setModalImage] = useState(null); // Image to be shown in the modal
    const [isModalOpen, setIsModalOpen] = useState(false); // Modal state


    


 

    // console.log(imageUrls)
    const viewBill = () => {
        setBillView(!billView);
    };


    const openModal = (url) => {
        setModalImage(url); // Set the image for the modal
        setIsModalOpen(true); // Open the modal
    };

    const closeModal = () => {
        setModalImage(null); // Clear the modal image
        setIsModalOpen(false); // Close the modal
    };



    useEffect(() => {
        const fetchImages = async () => {
            const urls = []; // Array to store fetched image URLs
           
            
            for (let i = 0; i < props.billImgArr.length; i++) {
              
                try {
                    const response = await axiosInstance.get(
                        `/api/v1/images/download-presigned-url?key=${props.billImgArr[i]}`
                    );
                    urls[i] = response.data.url; // Store the URL in the array
                } 
                catch (error) {
                    
                    console.error(`Error fetching image for ${props.billImgArr[i]}:`, error);
                    urls[i] = null; // Store null if there's an error

                } finally {
                   console.log("Done")
                }
            }
            
            setImageUrls(urls); // Update the state with the fetched URLs
            
        };

        if (billView && imageUrls.length===0) { // Only fetch images when the bill view is opened
            fetchImages();
        }

    }, [billView, props.billImgArr,imageUrls]);

    return (
        <div className="bill-request" >
            <div className="bill-name" onClick={viewBill}>
                <h4>
                    {billView ? <span style={{ marginRight: '15px',fontSize:"21px" }}>+</span>  :<span style={{ marginRight: '15px' }}>&#8212;</span>  }
                    {props.type}
                </h4>
                <h4 style={{ display: 'flex' }}>
                    <span>₹</span>
                    <span>{props.total}</span>
                </h4>
            </div>

            {billView && (
                <div className="bill-img">
                    {
                        props.billImgArr.map((img, index) => (
                        <div key={index} className="image-container">
                            {
                                (
                                    imageUrls[index] ? ( 
                                        <img src={imageUrls[index]} alt="Bill Details"  
                                        onClick={() => openModal(imageUrls[index])} />
                                    ) : 
                                    (
                                        <div className="skeleton"></div>   
                                    )
                                )
                            }
                        </div>
                    ))
                    }
                </div>
            )}

            {/* Modal Section */}
            {isModalOpen && (
                <div className="modal" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                       
                        <img src={modalImage} alt="Full View" className="modal-image" />
                
                    </div>
                </div>
            )}


        </div>
    );
}
